"use client"
import { useAuth0 } from "@auth0/auth0-react"
import {
  Avatar,
  Menu,
  Text,
  Flex,
  Spinner,
  Box,
  Button,
} from "@chakra-ui/react"
import { useColorModeValue } from "./ui/color-mode"
import { LuChevronDown } from "react-icons/lu"

const Profile = () => {
  const { user, isAuthenticated, isLoading, logout } = useAuth0()
  const menuBg = useColorModeValue("white", "gray.800")
  const menuBorder = useColorModeValue("gray.200", "gray.700")
  const menuShadow = useColorModeValue("lg", "dark-lg")
  const textColor = useColorModeValue("gray.800", "gray.200")
  const emailColor = useColorModeValue("gray.600", "gray.400")
  const hoverBg = useColorModeValue("gray.50", "gray.700")
  const separatorColor = useColorModeValue("gray.200", "gray.700")
  const buttonHoverBg = useColorModeValue("gray.100", "gray.700")

  // Avoid flashing a spinner on initial hydrate; render nothing until ready
  if (isLoading) {
    return null
  }

  if (!isAuthenticated || !user) {
    return null
  }

  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <Button 
          rounded="full" 
          cursor="pointer" 
          display="flex" 
          alignItems="center"
          variant="ghost"
          _hover={{ bg: buttonHoverBg }}
        >
          <Flex alignItems="center">
            <Avatar.Root
              size="sm"
              src={user.picture}
              name={user.name || "User"}
              mr={2}
              bg="blue.500"
              color="white"
            >
              <Avatar.Fallback
                w="100%"
                h="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bg="blue.500"
                color="white"
                fontWeight="semibold"
                fontSize="xs"
                p={0}
                m={0}
              >
                {user.name ? user.name[0].toUpperCase() : "U"}
              </Avatar.Fallback>
            </Avatar.Root>
            <Text display={{ base: "none", md: "flex" }} fontSize="sm" fontWeight="medium" mr={1}>
              {user.name?.split(" ")[0]}
            </Text>
            <LuChevronDown />
          </Flex>
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content 
          bg={menuBg} 
          borderColor={menuBorder}
          borderWidth="1px"
          borderRadius="md"
          boxShadow={menuShadow}
          minW="200px"
          py={1}
        >
          <Box px={4} py={3}>
            <Text fontWeight="bold" fontSize="sm" color={textColor} display="block">
              {user.name}
            </Text>
            <Text fontSize="xs" color={emailColor} mt={0.5} display="block">
              {user.email}
            </Text>
          </Box>
          <Menu.Separator borderColor={separatorColor} />
          <Menu.Item 
            asChild
            _hover={{ bg: hoverBg, cursor: "pointer" }}
            px={4}
            py={2}
          >
            <Box as="a" href="/settings" display="block" color={textColor} fontSize="sm">
              Settings
            </Box>
          </Menu.Item>
          <Menu.Separator borderColor={separatorColor} />
          <Menu.Item 
            onClick={() => {
              const next = encodeURIComponent(
                `${window.location.pathname}${window.location.search}${window.location.hash}`
              )
              logout({ 
                logoutParams: { returnTo: `${window.location.origin}/post-logout#next=${next}` }
              })
            }}
            _hover={{ bg: hoverBg, cursor: "pointer" }}
            px={4}
            py={2}
            color={textColor}
            fontSize="sm"
          >
            Sign Out
          </Menu.Item>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  )
}

export default Profile

